import React from "react";

const AboutAuth = () => {
  return (
    <div className="auth-container-1">
      <h1>Join the Dev Q community</h1>
      <p>Get unstuck — ask your coding questions</p>
      <p>Unlock privileges like voting and commenting</p>
      <p>Save your favorite tags and discussions</p>
      <p>Build your developer reputation</p>

      <p style={{ fontSize: "13px", color: "#007ac6" }}>
        Collaborate and share knowledge with developers worldwide.
      </p>
      <p style={{ fontSize: "13px", color: "#007ac6" }}>
        Start learning, sharing, and growing with Dev Q.
      </p>
    </div>
  );
};

export default AboutAuth;
